// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_2 from 'E:/KEFU/service-frontend/src/models/options';
import model_3 from 'E:/KEFU/service-frontend/src/.umi-production/plugin-initialState/@@initialState';
import model_1 from 'E:/KEFU/service-frontend/src/models/fileModel';

export const models = {
model_2: { namespace: 'options', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
model_1: { namespace: 'fileModel', model: model_1 },
} as const
